module.exports = __webpack_public_path__ + "img/47.72662cd0.jpg";